
import { Component, Vue, Prop } from 'vue-property-decorator'
import { BModal, BButton } from 'bootstrap-vue'
import { ConfirmModalData } from '@/interfaces/ConfirmModalData'

@Component({
  components: {
    BModal,
    BButton
  }
})
export default class ConfirmModal extends Vue {
  public visible = false;
  @Prop() readonly data!: ConfirmModalData

  public cancel() {
    this.visible = false
    if (this.data.resolve) { this.data.resolve(false) }
  }

  public confirm() {
    this.visible = false
    if (this.data.resolve) { this.data.resolve(true) }
  }

  show() {
    this.visible = true
  }
}
